import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiPost } from '../../utils/apiClient';
import { IMG, pageBg } from '../../data/santaStages';
import GameBanner from '../../components/GameBanner/GameBanner';
import useBlockInspect from '../../hooks/useBlockInspect';
import './ThankYouPage.css';

export default function ThankYouPage() {
  const user = useSelector((s) => s.auth.user);
  const [points, setPoints] = useState(null);
  const [totalTime, setTotalTime] = useState('');
  const [error, setError] = useState('');
  useBlockInspect();

  useEffect(() => {
    if (!user?.userId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await apiPost('/game/result', { userId: user.userId });
        if (cancelled) return;
        setPoints(res.points ?? 0);
        setTotalTime(res.total_time || '00:00');
      } catch (err) {
        console.error(err);
        if (!cancelled) setError('Unable to load your score. Please refresh.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <div className="santa-thanks" style={pageBg('gamebg.jpg', 'bgmob.jpg')}>
      <div className="container-fluid">
        <GameBanner />
        <div className="row reveal-wrap">
          <div className="col-sm-8 col-md-8 col-lg-8 col-xs-12 auto">
            <div className="log-title reveal">
              <p>
                <b>
                  OMG The kidnapper is Santa Claus!<br />Well Well Well! Wondering why Santa Claus would fake a kidnapping?
                </b>
              </p>
              <p>
                Santa made it appear as BurgerMeister MeisterBurger had kidnapped him, so if you guessed that BM did this you followed the clues correctly! Bravo!
              </p>
              <p>
                You might be wondering why Santa would play such an elaborate prank this close to Christmas. You see, Santa and the elves are searching for the perfect apprentice. This special team must work well with others, show undying love for Christmas, exhibit exceptional leadership skills, and solve problems under pressure.
              </p>
              <p>Nobody here at Santa&apos;s Workshop solved the case, but you did!</p>
            </div>
          </div>
        </div>
        <div className="row thanks-foot">
          <div className="col-md-12 auto">
            <img src={`${IMG}/logo.gif`} className="thankyou-logo" alt="" />
          </div>
          <div className="col-md-12 text-center score">
            {error ? error : (
              points == null
                ? 'Loading…'
                : `Your score is ${points} out of 9 in ${totalTime} minutes.`
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
